export default __webpack_public_path__ + "static/media/logo-only-white.041f1894.svg";